module.exports = __webpack_public_path__ + "img/air-dr.daf8b136.jpg";